import React, { useContext, useEffect, useState } from "react";
import { message, Modal, Form, Input } from "antd";
import { UserContext } from "../../context/UserContext";
import inputStyles from "../../styles/Custom/Input.module.css";
import { raiseDeletePaymentApi } from "../../services/receptionist.services";
import modalStyles from "./DeleteReasonModal.module.css";

const DeletePaymentModal = ({ open, setOpen, editData, refresh }) => {
  const { userDetails } = useContext(UserContext);
  const [reason, setReason] = useState(null);
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia("(max-width: 768px)").matches
      : false
  );

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  const onFinish = () => {
    if (editData) {
      raiseDeletePaymentApi({
        id: editData,
        reason: reason,
      })
        .then((res) => {
          message.success(res?.data?.message);
          setOpen(false);
          refresh();
        })
        .catch((err) => {
          message.error(err?.response?.data?.message);
        });
    } else {
      message.error("Please select a practitioner");
    }
  };

  return (
    <Modal
      open={open}
      onCancel={() => setOpen(false)}
      onOk={onFinish}
      title={isMobile ? "Reason" : undefined}
      centered={!isMobile}
      width={isMobile ? "min(400px, calc(100vw - 24px))" : undefined}
      wrapClassName={isMobile ? modalStyles.compactModalWrap : undefined}
      okText="OK"
      cancelText="Cancel"
    >
      <Form.Item
        label={isMobile ? undefined : "Reason"}
        name="Reason"
        className={isMobile ? modalStyles.compactFormItem : undefined}
        style={isMobile ? { marginBottom: 0 } : undefined}
      >
        <Input.TextArea
          placeholder="Enter reason"
          className={inputStyles.mdInput}
          style={{ width: isMobile ? "100%" : "300px" }}
          rows={isMobile ? 3 : undefined}
          onChange={(e) => setReason(e.target.value)}
        />
      </Form.Item>
    </Modal>
  );
};

export default DeletePaymentModal;
